export default [
{
    path: 'customList',
    name: {list:['数字店铺','运营','店铺装修','移动端装修']},
    component: () => import('@/views/customPage/list/index.vue')
},
{
    path: 'sharingApplets',
    name: {list:['数字店铺','运营','店铺装修','店铺推广']},
    component: () => import('@/views/customPage/sharingApplets/index.vue')
},
{
    path: 'miniPage',
    name: {list:['数字店铺','运营','微页面','微页面']},
    component: () => import('@/views/customPage/miniPage/index.vue')
},
{
    path: 'buyerCustomList',
    name: {list:['数字供销','装修','H5装修','首页装修']},
    component: () => import('@/views/customPageH5/list/index.vue')
},
{
    path: 'buyerSpecialList',
    name: {list:['数字供销','装修','H5装修','专题装修']},
    component: () => import('@/views/customPageH5/list/index.vue')
},
// name: {list:['数字供销','设置','基本设置','站点配置']},
{
    path: 'saleCatgList',
    name: {list:['数字供销','商城','产品管理','销售分类']},
    component: () => import('@/views/productManage/saleCatgList.vue')
  },
  {
    path: 'Site',
    name: {list:['数字供销','设置','基本设置','站点配置']},
    component: () => import('@/views/conformity/Site.vue')
  },
  {
    path: 'commissionSet',
    name: {list:['数字供销','设置','基本设置','佣金配置']},
    component: () => import('@/views/setUp/commissionSet.vue')
  },
  {
    path: 'szgxOrderList',
    name: {list:['数字供销','商城','订单管理','订单列表']},
    component: () => import('@/views/productManage/order/orderList.vue'),
      meta: { 
      // 标识这个页面需要 KeepAlive 缓存
      keepAlive: true, 
      // 标识从菜单点击进入时需要刷新
      isMenu: true 
    }
  },
  {
    path: 'szgxOrderDetails',
    name: {list:['数字供销','商城','订单管理','订单列表','订单详情']},
    component: () => import('@/views/productManage/order/orderDetails.vue')
  },
  {
    path: 'szgxRefundOrderList',
    name: {list:['数字供销','商城','售后管理','售后列表']},
    component: () => import('@/views/productManage/order/refundOrderList.vue'),
      meta: { 
      // 标识这个页面需要 KeepAlive 缓存
      keepAlive: true, 
      // 标识从菜单点击进入时需要刷新
      isMenu: true 
    }
  },
  {
    path: 'szgxRefundOrderDetails',
    name: {list:['数字供销','商城','售后管理','售后列表','售后详情']},
    component: () => import('@/views/productManage/order/refundOrderDetails.vue')
  },
]